import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface EditRegionParams {
	id: number;
	payload: Record<string, unknown>;
}

const editRegion = async ({ id, payload }: EditRegionParams) => {
	const response = await cmsClient.patch(
		`/homepage/admin/store/region/${id}/`,
		payload
	);

	return response.data;
};

const useEditRegion = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Region updated" />, {
			hideProgressBar: true
		});
	};

	const onError = (error: unknown) => {
		const detail = (error as any)?.response?.data;
		const message =
			detail?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : null) ??
			"Something went wrong, try again";
		const safeMessage = message.length > 200 ? message.slice(0, 200) + "..." : message;

		toast.error(<CustomToast type="Error" message={safeMessage} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-regions"]);
	};

	return useMutation(editRegion, { onSuccess, onError, onSettled });
};

export default useEditRegion;
